import axios from "axios";

const useRolesProvider = () => {
  const listRolesProvider = ({ page, search }) => {
    return axios({
      method: "get",
      url: `roles?page=${page}`,
      params: { search }
    });
  };

  const addRoleProvider = (data) => {
    return axios({
      method: "post",
      url: `roles`,
      data
    });
  };

  const editRoleProvider = (id, data) => {
    return axios({
      method: "put",
      url: `roles/${id}`,
      data
    });
  };

  const deleteRoleProvider = (id) => {
    return axios({
      method: "delete",
      url: `roles/${id}`
    });
  };

  const getRoleByIdProvider = (id) => {
    return axios({
      method: "get",
      url: `roles/${id}`
    });
  };

  return {
    listRolesProvider,
    addRoleProvider,
    editRoleProvider,
    deleteRoleProvider,
    getRoleByIdProvider,
  };
};

export default useRolesProvider;
